import { Component } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './frame.component.html',
  styleUrl: './frame.component.scss'
})
export class FrameComponent { }